// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__3SIRI","content":"Page_content__2COkr","bodyNoScroll":"Page_bodyNoScroll__1nwPb"};